<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
.table th,
.table td {
  padding: 0.6rem 0.1rem;
  white-space: nowrap;
  text-align: center !important;
}
a:hover {
  cursor: pointer;
}
</style>
